import styled from 'styled-components';
import { white } from 'styles/Colors';

export const HomeMenuCardWrapper = styled.div<{ backgroundImage: string; height: string; width: string }>`
  position: relative;
  background: ${white};
  border-radius: 5px;
  background-repeat: no-repeat;
  cursor: pointer;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.16);

  width: ${(props) => props.width};
  background-image: ${(props) => props.backgroundImage};
  height: ${(props) => props.height};

  &:hover {
    box-shadow: 0 4px 17px 2px rgba(0, 0, 0, 0.16);
  }

  &.disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;
